import React, { useContext, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { toast } from "react-toastify";
import { ConfirmModal } from ".";
import { DesktopContainer } from "../layouts";
import { constants, deviceDetect, UserContext } from "../utils";

export default function MobileHome(props) {
  const userCtx = useContext(UserContext);
  const { currentUser, appVersion, savedDevice, setSavedDevice } = userCtx;
  const [confirmScanner, setConfirmScanner] = useState(false);

  // A rugged handheld's scanner capability can't be auto-detected (its UA looks like a plain Android
  // phone), so offer a manual toggle to correct a mis-identified device. Hidden on iPhones (no
  // built-in scanner) and on desktops.
  const showScannerToggle = savedDevice?.isMobile && !deviceDetect.isNoScannerMobile();
  const hasScanner = savedDevice?.hasScanner === true;

  function applyScannerChoice() {
    const target = hasScanner
      ? constants.DEVICE_TYPES.find(d => d.isMobile && !d.hasScanner)  // turn scanner off -> Mobile
      : constants.DEVICE_TYPES.find(d => d.isMobile && d.hasScanner);  // turn scanner on -> Handheld Scanner
    setSavedDevice(target);
    setConfirmScanner(false);
    toast.success(hasScanner ? "Scanner turned off for this device." : "Scanner enabled for this device.");
  }

  return (
    <DesktopContainer screenName="Mobile">
      <br />
      <div>
        <Card className="mobileGrayBgAlt">
          <CardTitle className="mobileBlueBgAlt py-2 px-2 text-white fw-bold">
            Welcome, {currentUser?.fullName}
          </CardTitle>
          <CardBody className="mobileGrayBgAlt">
            <Row className="align-items-center my-1">
              <Col className="text-black h6 fw-bold" xs={12}>
                Please make a selection from the menu to navigate to your desired feature
              </Col>
            </Row>
            <Row className="align-items-center my-1">
              <Col className="text-black h6" xs={12}>
                Navigating with the browser "back" button may not always behave as expected.
              </Col>
            </Row>

            {showScannerToggle ? (
              <Row className="align-items-center my-2">
                <Col xs={12}>
                  <Button className="shredButton w-100 btn-md" onClick={() => setConfirmScanner(true)}>
                    {hasScanner ? "This device does not have a scanner" : "This device has a scanner"}
                  </Button>
                </Col>
              </Row>
            ) : null}

            <br />
            <Row className="align-items-center my-1">
              <Col className="text-blue" xs={12}>
                Service Thread Insight Application
              </Col>
            </Row>
            <Row className="align-items-center my-1">
              <Col className="text-blue" xs={12}>
                &copy; 2022 - {new Date().getFullYear()} : All rights reserved
              </Col>
            </Row>
            <Row className='align-items-center my-1'>
              <Col className='text-blue'>
                  Version {appVersion}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>

      <ConfirmModal
        confirmDelete={confirmScanner}
        header="Barcode Scanner"
        warningMessage={
          hasScanner
            ? <>Turn off handheld scanner mode on this device?</>
            : <>Enable handheld scanner mode on this device? Only do this if it has a built-in barcode scanner.</>
        }
        approveConfirmDelete={applyScannerChoice}
        declineConfirmDelete={() => setConfirmScanner(false)}
      />
    </DesktopContainer>
  );
}
